import React, { Component } from "react";
import PropTypes from "prop-types";
import { CustomTextArea } from "./style";

export default class CommonTextArea extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <CustomTextArea {...this.props}/>
    );
  }
}

CommonTextArea.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  type: PropTypes.any,
  maxLength: PropTypes.number,
  pattern : PropTypes.any,
  min : PropTypes.any,
  onKeyPress : PropTypes.func,
  step : PropTypes.any,
  disabled : PropTypes.any,

};